import { Component, Injector } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { ASSET_MAINTENANCE_TYPE } from 'assets-model';
import { AssetMaintenanceService, RefCodeStorage } from 'assets-service';
import { AssetMaintenanceSearchComponentBase } from './asset-maintenance-search.component.base';
import { AssetMaintenance } from 'assets-model';


@Component({
  selector: 'app-asset-maintenance-search',
  templateUrl: './asset-maintenance-search.component.html',
  styleUrls: ['./asset-maintenance-search.component.scss']
})
export class AssetMaintenanceSearchComponent extends AssetMaintenanceSearchComponentBase {

  displayedColumns: string[] = ['assetMaintenanceId', 'assetId', 'maintenanceBy', 'maintenanceType', 'maintenanceDate', 'comments', 'createdBy', 'createdDate', 'actions'];
  disabledColumns: string[] = ['assetMaintenanceId', 'assetId', 'comments'];


  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected assetMaintenanceService: AssetMaintenanceService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected formStorage: FormStorage,
    protected injector: Injector) {
    super(route, router, userStorage, dialog, assetMaintenanceService, refCodeStorage, fb, formStorage, injector);
  }

  get assetIdParameter() {
    return this.getCombinedParams()?.assetId;
  }

  get composedAssetClassParameter() {
    return this.getCombinedParams()?.composedAssetClass;
  }

  protected onInitAsyncComplete() {
    this.maintenanceTypeLoadSelectionList();
    if (this.restoreFormFromParams(this.searchForm)) {
      this.disableFormControlsFromParams(this.searchForm);
    } else {
      this.resetSearchForm();
      this.restoreFormChanges();
    }

    super.onInitAsyncComplete();
  }

  resetSearchForm() {
    // placeholder
  }

  protected transformParamsToModelSetters(params: Params): {
    [key: string]: (value: any, formControl: FormControl, formControlName: string) => void
  } {
    return this.transformAllPropertiesToModelSetters();
  }

  allowsDelete(element: AssetMaintenance): boolean {
    return this.userStorage?.currentUserHasAnyAuthority("ACTS_AT_NATIONAL_LEVEL");
  }

  allowsCreate() {
    var assetId = this.assetIdParameter;
    return assetId != null;
  }

  createRoute() {
    var assetId = this.assetIdParameter;
    var composedAssetClass = this.composedAssetClassParameter;
    if (assetId) {
      return [...ASSET_MAINTENANCE_TYPE.createRouteBase, assetId, composedAssetClass];
    }
    return super.createRoute();
  }

  editRoute(item: AssetMaintenance) {
    var assetId = this.assetIdParameter;
    var composedAssetClass = this.composedAssetClassParameter;
    if (assetId) {
      return [...ASSET_MAINTENANCE_TYPE.editRouteBase, item.assetMaintenanceId, composedAssetClass];
    }
    return super.editRoute(item);
  }

  viewRoute(item: AssetMaintenance) {
    var assetId = this.assetIdParameter;
    var composedAssetClass = this.composedAssetClassParameter;
    if (assetId) {
      return [...ASSET_MAINTENANCE_TYPE.viewRouteBase, item.assetMaintenanceId, , composedAssetClass];
    }
    return super.viewRoute(item);
  }

  /*
    backRoute() {
      var assetId = this.assetIdParameter;
      if (assetId) {
        return [...ASSET_TYPE.searchRouteBase, assetId];
      }
      return super.backRoute();
    }
  */

}



